var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import { Alert, Box, Button, Card, CardContent, Divider, Typography, } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useProcessLeagueTeamInvitation, useRetrieveLeagueTeamInvitation, } from "../api/InvitationApiProvider";
import { ROUTES } from "../breadcrumbs/routeConfig";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var LeagueTeamInvitationDetail = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveLeagueTeamInvitation({ id: id }), invitation = _a.data, isLoading = _a.isLoading, error = _a.error;
    var navigate = useNavigate();
    var _b = __read(React.useState(""), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var acceptMutation = useProcessLeagueTeamInvitation({
        invitation: invitation,
        onMutate: function () { },
        onSuccess: function () { return navigate("/leagues/".concat(invitation.league)); },
        onError: function () { return setErrorMessage("Failed to accept invitation."); },
    });
    var declineMutation = useProcessLeagueTeamInvitation({
        invitation: invitation,
        onMutate: function () { },
        onSuccess: function () { return navigate("/invitations"); },
        onError: function () { return setErrorMessage("Failed to decline invitation."); },
    });
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error || !invitation) {
        return _jsx(ErrorView, { error: error });
    }
    var isPending = invitation.status === "PENDING";
    var isProcessing = acceptMutation.isLoading || declineMutation.isLoading;
    return (_jsxs(React.Fragment, { children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: "League Invitation" }), _jsx(Divider, { sx: { my: 2 } }), _jsx(Card, { variant: "outlined", sx: { maxWidth: 600 }, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h5", gutterBottom: true, children: invitation.leagueName }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 1 }, children: ["Your team ", _jsx("strong", { children: invitation.teamName }), " has been invited"] }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 1 }, children: ["Invited by ", invitation.inviterFirstName, " ", invitation.inviterLastName] }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: formatDistanceToNow(new Date(invitation.createdAt), {
                                addSuffix: true,
                            }) }), invitation.message && (_jsxs(Typography, { variant: "body1", sx: {
                                mb: 2,
                                fontStyle: "italic",
                                p: 2,
                                bgcolor: "grey.50",
                                borderRadius: 1,
                            }, children: ["\u201C", invitation.message, "\u201D"] })), invitation.mergeTeamName && (_jsxs(Alert, { severity: "warning", icon: _jsx(MergeTypeIcon, {}), sx: { mb: 2 }, children: [_jsxs(Typography, { variant: "body2", sx: { mb: 1 }, children: [_jsx("strong", { children: "Data merge:" }), " All league data (results, standings, stats) from", " ", _jsx(Link, { to: ROUTES.TEAM_DETAIL.replace(":id", String(invitation.mergeTeam)), children: invitation.mergeTeamName }), " ", "will be transferred to", " ", _jsx(Link, { to: ROUTES.TEAM_DETAIL.replace(":id", String(invitation.team)), children: invitation.teamName }), " ", "when you accept."] }), _jsx(Typography, { variant: "body2", children: "Review both teams before accepting." })] })), isPending ? (_jsxs(Box, { sx: { display: "flex", gap: 2, mt: 2 }, children: [_jsx(Button, { variant: "contained", color: "success", startIcon: _jsx(CheckCircleIcon, {}), disabled: isProcessing, onClick: function () {
                                        return acceptMutation.mutate({
                                            id: invitation.id,
                                            status: "ACCEPTED",
                                        });
                                    }, children: acceptMutation.isLoading ? "Accepting..." : "Accept" }), _jsx(Button, { variant: "outlined", color: "error", startIcon: _jsx(DoNotDisturbIcon, {}), disabled: isProcessing, onClick: function () {
                                        return declineMutation.mutate({
                                            id: invitation.id,
                                            status: "DECLINED",
                                        });
                                    }, children: declineMutation.isLoading ? "Declining..." : "Decline" })] })) : (_jsx(Typography, { variant: "body1", color: invitation.status === "ACCEPTED" ? "success.main" : "error.main", sx: { mt: 2, fontWeight: "bold" }, children: invitation.status === "ACCEPTED"
                                ? "You accepted this invitation"
                                : "You declined this invitation" }))] }) }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
